import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {ISdkComponentRenderer} from '../../services/sdk-component-factory/sdk-component-factory.service.interface';
import {observer} from 'mobx-react';
import styled, {AnyStyledComponent} from 'styled-components';
import classNames from 'classnames';


export interface SdkComponentProps {
  componentId: string;
  className?: string;
  sdkProps?: any;
  box?: AnyStyledComponent | React.ComponentType<any>;
  onClick?: React.MouseEventHandler;
}


const DefaultBox = styled.div``;

export const SdkComponent = observer(class SdkComponent extends OrbitComponent<SdkComponentProps> {

  private _elementRef: HTMLElement | null = null;
  private _captureElementRef = (element: HTMLElement | null) => {
    this._elementRef = element;
    this._renderSdkComponent();
  };


  private _sdkComponentRenderer: ISdkComponentRenderer | null = null;
  private get sdkComponentRenderer(): ISdkComponentRenderer {
    if(!this._sdkComponentRenderer) {
      this._sdkComponentRenderer = this.services.sdkComponentFactory.createComponentRenderer(this.props.componentId);
    }
    return this._sdkComponentRenderer;
  }

  private _disposeSdkComponent() {
    this.sdkComponentRenderer.dispose();
  }

  private _renderSdkComponent() {

    //first we destroy the old component if there is one.
    this._disposeSdkComponent();

    if(!this._elementRef) {
      return;
    }

    this.sdkComponentRenderer.render(this._elementRef, this.props.sdkProps);
  }

  componentDidUpdate(prevProps: SdkComponentProps, prevState: any, snapshot: any) {
    if(JSON.stringify(prevProps?.sdkProps) !== JSON.stringify(this.props.sdkProps)) {
        this._renderSdkComponent();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this._disposeSdkComponent();
  }

  render() {
    let Box: AnyStyledComponent | React.ComponentType<any> = DefaultBox;
    if(this.props.box) {
      Box = this.props.box;
    }
    return (
      <Box className={classNames(this.props.className)}
           ref={this._captureElementRef}
           onClick={(e) => this._passOnClick(e)}>
      </Box>
    );
  }

  private _passOnClick(e: React.MouseEvent) {
    if(this.props.onClick)
      this.props.onClick(e);
  }
});

